// extracted by mini-css-extract-plugin
export var section = "Audience-module--section--PnQ5j";
export var container = "Audience-module--container--FRiO1";
export var area = "Audience-module--area--HcTie";
export var spacer = "Audience-module--spacer--Wqmh1";
export var type = "Audience-module--type--mR2Yr";
export var contactButton = "Audience-module--contactButton--PtOGT";